import { Box, styled, Typography } from "@mui/material";
import React from "react";
import { formatChangeLetters } from "../../utils/dateFormat";

const FeedsCart = ({
  data,
  handleEdit = () => null,
  handleDelete = () => null,
}) => {
  return (
    <Container>
      <ImageContainer>
        <Image src={data?.feedImageUrl} />
      </ImageContainer>
      <Typography fontSize={14} fontWeight={600} color="black">
        {data?.title}
      </Typography>
      <Typography fontSize={12} fontWeight={400} color="black">
        Streamed on{" "}
        <span style={{ fontWeight: 600 }}>
          {formatChangeLetters(data?.streamedOn)}
        </span>
      </Typography>
      <Typography fontSize={14} fontWeight={400} color="gray">
        {data?.description}
      </Typography>
      <Box display={"flex"} gap="1rem">
        <Typography
          fontSize={14}
          fontWeight={400}
          color="blue"
          sx={{ cursor: "pointer" }}
          onClick={() => handleEdit(data)}
        >
          Edit
        </Typography>
        <Typography
          sx={{ cursor: "pointer" }}
          fontSize={14}
          fontWeight={400}
          color="red"
          onClick={() => handleDelete(data)}
        >
          Delete
        </Typography>
      </Box>
    </Container>
  );
};

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.3rem",
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  aspectRatio: 2.4,
  height: "100%",
  borderRadius: 8,
  overflow: "hidden",
}));
const Image = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "",
}));

export default FeedsCart;
